module.exports = __webpack_public_path__ + "static/media/cw.9c06626e.svg";